import {Intent, OverlayToaster, Toast} from "@blueprintjs/core";
import {observer} from "mobx-react";
import * as React from "react";
import {useEffect} from "react";
import {useLocation} from "react-router-dom";

import {useToastStore} from "../../../stores/store-hooks";
import {SimpleToast} from "../../../stores/toast-store";
import {getLoginUrl} from "../../../utils/auth-util";
import {usePageChangingContext} from "../page-changing-context/page-changing-context";

export const GlobalToaster: React.FC = observer(() => {
    const pageChangingContext = usePageChangingContext();
    const toastStore = useToastStore();
    const location = useLocation();

    useEffect(() => {
        return pageChangingContext.listen(() => toastStore.routeChanged());
    }, [pageChangingContext, toastStore]);

    return (
        <OverlayToaster>
            {toastStore.httpError && (
                <Toast
                    intent={toastStore.httpErrorDetail!.intent}
                    onDismiss={() => toastStore.setHttpError(null)}
                    message={
                        <span style={{whiteSpace: "pre-line"}}>
                            {toastStore.httpErrorDetail!.message}
                        </span>
                    }
                />
            )}

            {toastStore.isEditLeaveShown && (
                <Toast
                    message={"離れた編集画面に未保存の変更があります。"}
                    intent={Intent.WARNING}
                    action={{
                        onClick: () => {
                            toastStore.backToEditLeave();
                        },
                        text: "編集画面に戻る",
                    }}
                    onDismiss={() => {
                        toastStore.hideEditLeave();
                    }}
                    timeout={60000}
                />
            )}

            {toastStore.simpleToast && (
                <Toast
                    message={
                        toastStore.simpleToast === SimpleToast.SESSION_EXPIRED ? (
                            <span>
                                セッションの有効期限が切れました。 再度
                                <a href={getLoginUrl(location)}>ログイン</a>
                                してください。
                            </span>
                        ) : (
                            toastStore.simpleToastDetail!.text
                        )
                    }
                    intent={toastStore.simpleToastDetail!.intent}
                    timeout={toastStore.simpleToast === SimpleToast.SESSION_EXPIRED ? 10000 : 3000}
                    onDismiss={() => {
                        toastStore.setSimpleToast(null);
                    }}
                />
            )}
        </OverlayToaster>
    );
});
